import React from 'react'

import { Card, CardContent, CardHeader } from '@mui/material'

import { DescriptionListTable } from 'components/table'
import { renderProgress, renderRegion, renderSpent } from 'utils/render/campaign-details'

const config = [
  {
    title: 'Collection',
    render: renderProgress('collection', true)('matchedViews', 'exchangeTotalViews'),
  },
  {
    title: 'CTR',
    render: renderProgress('ctr')('exchangeTotalClicks', 'exchangeTotalViews', 'percent', true),
  },
  {
    title: 'Plan',
    render: renderProgress('plan')('exchangeTotalViews', 'rtbTotalViews'),
  },
  {
    title: 'Completion daily',
    render: renderProgress('completionDaily', true)('exchangeTotalViewsPerDay', 'rtbTotalViewsPerDay'),
  },
  {
    title: 'Viewability',
    render: renderProgress('viewability')('exchangeViewableViews', 'exchangeTotalViews'),
  },
  {
    title: 'Spent',
    render: renderSpent,
  },
  {
    title: 'Region',
    render: renderRegion,
  },
]

type CampaignDetailsAdExchangeProps = {
  data: Record<string, any>
}

const CampaignDetailsAdExchange = ({ data }: CampaignDetailsAdExchangeProps) => (
  <Card>
    <CardHeader title={`AdExchange: ${data.type.toUpperCase()}`} />
    <CardContent>
      <DescriptionListTable config={config} data={data} titleCellStyle={{ width: 100 }} />
    </CardContent>
  </Card>
)

export default CampaignDetailsAdExchange
